// DEPLOY-PROBE-bump

/**
 * Match person display names regardless of:
 * - Unicode NFKC compatibility (e.g. half-width ｸﾞ vs full-width グ)
 * - Unicode space separators (Zs), e.g. 國吉　康助 vs 國吉康助
 */
export function compactForMatch(name: string | null | undefined): string {
  if (name == null) return '';
  const n = name.normalize('NFKC');
  return n.replace(/\p{Zs}/gu, '');
}

export function sameName(a: string | null | undefined, b: string | null | undefined): boolean {
  return compactForMatch(a) === compactForMatch(b);
}

export function compactContainsQuery(fullName: string | null | undefined, query: string | null | undefined): boolean {
  const fc = compactForMatch(fullName);
  const qc = compactForMatch(query);
  return qc.length > 0 && fc.includes(qc);
}
